import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useResetMeterFrames } from "@/api/media-transmitters/mutations";

export function useResetMeterFlow(sn: string) {
	const { t } = useTranslation();
	const [pendingMeterIds, setPendingMeterIds] = useState<string[] | null>(null);
	const reset = useResetMeterFrames();

	return {
		pendingMeterIds,
		pendingMeterId:
			pendingMeterIds && pendingMeterIds.length === 1
				? pendingMeterIds[0]
				: null,
		open: (meterIds: string | string[]) =>
			setPendingMeterIds(Array.isArray(meterIds) ? meterIds : [meterIds]),
		close: () => setPendingMeterIds(null),
		isPending: reset.isPending,
		confirm: () => {
			if (!pendingMeterIds || pendingMeterIds.length === 0) return;
			reset.mutate(
				{ sn, serialNumbers: pendingMeterIds },
				{
					onSuccess: () => {
						toast.success(t("mediaTransmitters.resetSuccess"));
						setPendingMeterIds(null);
					},
					onError: () => {
						toast.error(t("mediaTransmitters.resetError"));
					},
				},
			);
		},
	};
}
